






















































import { defineComponent, PropType } from '@nuxtjs/composition-api';
import AppImage from '~/components/partials/App/AppImage.vue';
import AppLink from '~/components/partials/App/AppLink.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { REQUEST_NUM } from '~/constants';
import { url } from '~/utils';
import { RecommendItem } from '~/types/common/silverEgg';
import RecommendArticles from './RecommendArticles.vue';

export default defineComponent({
  components: {
    AppImage,
    AppLink,
    RecommendArticles,
  },
  props: {
    popularArticles: {
      type: Array as PropType<RecommendItem[]>,
      required: true,
    },
    rqid: {
      type: String,
      default: '',
    },
    spec: {
      type: String,
      default: '',
    },
    pagination: {
      type: Number,
      default: 1,
    },
  },
  setup(props, { emit }) {
    const { clickNotify } = useSilverEggApi();

    const defaultImage = require('~/assets/svg/article-thumbnail-no-img-sp.svg');

    const rankingImgs = [];
    for (let i = 1; i <= REQUEST_NUM; i++) {
      rankingImgs.push(require(`~/assets/images/ranking/${i}.png`));
    }

    const sendClickRequest = async (articleId: string) => {
      await clickNotify({
        itemId: articleId,
        spec: props.spec,
        rqid: props.rqid,
      });
    };

    const setPagination = (value: number) => {
      emit('set-pagination', value);
    };

    return { url, defaultImage, rankingImgs, sendClickRequest, setPagination };
  },
});
